import React from 'react';
import { useCart } from '../context/CartContext';
import '../styles/components/Cart.css';

const Cart = () => {
  const { cart, cartTotal, removeFromCart, updateQuantity, checkout } = useCart();

  if (cart.length === 0) {
    return (
      <div className="cart-container empty">
        <h2>Your cart is empty</h2>
        <p>Add some products to your cart to proceed with checkout.</p>
      </div>
    );
  }

  return (
    <div className="cart-container">
      <h2>YOUR CART</h2>
      
      <div className="cart-items">
        {cart.map((item) => (
          <div key={item.variantId} className="cart-item">
            <div className="cart-item-image">
              <img src={item.image} alt={item.title} />
            </div>
            
            <div className="cart-item-details">
              <h3>{item.title}</h3>
              <p>{item.variantTitle !== 'Default Title' ? item.variantTitle : ''}</p>
              <p className="cart-item-price">{(item.price * item.quantity).toFixed(2)} SEK</p>
            </div>
            
            <div className="cart-item-quantity">
              <button 
                onClick={() => updateQuantity(item.variantId, item.quantity - 1)}
                disabled={item.quantity <= 1}
              >
                -
              </button>
              <span>{item.quantity}</span>
              <button onClick={() => updateQuantity(item.variantId, item.quantity + 1)}>
                +
              </button>
            </div>
            
            <button 
              className="remove-item" 
              onClick={() => removeFromCart(item.variantId)}
            >
              &times;
            </button>
          </div>
        ))}
      </div>
      
      <div className="cart-summary">
        <div className="cart-total">
          <span>Total:</span>
          <span>{cartTotal.toFixed(2)} SEK</span>
        </div>
        
        <button className="checkout-button" onClick={checkout}>
          PROCEED TO CHECKOUT
        </button>
      </div>
    </div>
  );
};

export default Cart; 